
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5A2f8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $9bc5aba24dc3fe97$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Traditional)
var $9bc5aba24dc3fe97$export$2e2bcd8739ae039 = {
    'people.menu.renotify.flag.description': "\u6211\u5011\u6B63\u5728\u900F\u904E\u96FB\u5B50\u90F5\u4EF6\u5411\u6BCF\u500B\u4EBA\u50B3\u9001\u63D0\u9192\u3002\u9019\u6700\u591A\u9700\u8981\u4E00\u5206\u9418\u7684\u6642\u9593\u3002",
    'people.menu.renotify.flag.description.confluence': "\u63D0\u9192\u5718\u968A\u6210\u54E1",
    'people.menu.renotify.flag.title': "\u6B63\u5728\u50B3\u9001\u63D0\u9192",
    'people.menu.renotify.flag.title.confluence': "\u6B63\u5728\u91CD\u65B0\u50B3\u9001\u9080\u8ACB\u96FB\u5B50\u90F5\u4EF6",
    'people.menu.renotify.menu.description': "{userCount, plural, other {\u6709 {userCount,number} \u4EBA\u5C1A\u672A\u63A5\u53D7 {product} \u7684\u9080\u8ACB\u3002\u67E5\u770B\u7F3A\u5C11\u7684\u4EBA\u54E1\u4E26\u5411\u4ED6\u5011\u50B3\u9001\u63D0\u9192\u3002}}",
    'people.menu.renotify.menu.description.confluence': "\u6709\u4E9B\u4EBA\u54E1\u5C1A\u672A\u63A5\u53D7 Confluence \u7684\u9080\u8ACB\u3002\u67E5\u770B\u7F3A\u5C11\u7684\u4EBA\u54E1\u4E26\u5411\u4ED6\u5011\u50B3\u9001\u63D0\u9192\u3002",
    'people.menu.renotify.menu.dismiss': "\u95DC\u9589",
    'people.menu.renotify.menu.dismiss.confluence': "\u7A0D\u5F8C\u518D\u8AAA",
    'people.menu.renotify.menu.remind': "\u63D0\u9192\u5718\u968A\u6210\u54E1",
    'people.menu.renotify.menu.remind.confluence': "\u63D0\u9192\u5718\u968A\u6210\u54E1",
    'people.menu.renotify.menu.title': "\u6BCF\u500B\u4EBA\u90FD\u53C3\u8207\u4E86\u55CE\uFF1F",
    'people.menu.renotify.modal.copied': "\u9023\u7D50\u5DF2\u8907\u88FD",
    'people.menu.renotify.modal.copy': "\u8907\u88FD\u9080\u8ACB\u9023\u7D50",
    'people.menu.renotify.modal.description': "\u6211\u5011\u53EF\u4EE5\u900F\u904E\u96FB\u5B50\u90F5\u4EF6\u5C07\u63D0\u9192\u50B3\u9001\u7D66\u7F3A\u5E2D\u6210\u54E1\uFF0C\u60A8\u4E5F\u53EF\u4EE5\u81EA\u884C\u5206\u4EAB\u9080\u8ACB\u9023\u7D50\u3002",
    'people.menu.renotify.modal.description.confluence': "\u518D\u6B21\u50B3\u9001\u9080\u8ACB\u96FB\u5B50\u90F5\u4EF6\uFF0C\u6216\u8907\u88FD\u4E26\u5206\u4EAB\u9080\u8ACB\u9023\u7D50\u3002",
    'people.menu.renotify.modal.dismiss': "\u53D6\u6D88",
    'people.menu.renotify.modal.resend': "\u50B3\u9001\u63D0\u9192",
    'people.menu.renotify.modal.resend.confluence': "\u91CD\u65B0\u50B3\u9001\u9080\u8ACB",
    'people.menu.renotify.modal.title': "\u63D0\u9192\u7F3A\u5E2D\u6210\u54E1",
    'people.menu.renotify.modal.title.confluence': "\u63D0\u9192\u7F3A\u5C11\u7684\u5718\u968A\u6210\u54E1",
    'ptc.pm.collaborators.title': "\u60A8\u7684\u5171\u540C\u4F5C\u696D\u8005",
    'ptc.pm.error-heading': "\u767C\u751F\u932F\u8AA4",
    'ptc.pm.error-image-alt-text': "\u6A5F\u5668\u4EBA\u6545\u969C\uFF0C\u591A\u4F4D\u4EBA\u54E1\u6B63\u5728\u4FEE\u5FA9\u6B64\u554F\u984C\u3002",
    'ptc.pm.error-text': "\u6211\u5011\u6703\u6301\u7E8C\u8FFD\u8E64\u9019\u4E9B\u932F\u8AA4\uFF0C\u5982\u679C\u91CD\u65B0\u6574\u7406\u4E4B\u5F8C\u4ECD\u7121\u6CD5\u4FEE\u5FA9\uFF0C\u60A8\u53EF\u4EE5\u96A8\u6642\u8207\u6211\u5011\u806F\u7E6B",
    'ptc.pm.num-members': "{memberCount, plural, other {{memberCount,number} \u4F4D\u6210\u54E1}}",
    'ptc.pm.people': "\u4EBA\u54E1",
    'ptc.pm.teams': "\u5718\u968A",
    'ptc.pm.view-your-profile': "\u6AA2\u8996\u60A8\u7684\u8A2D\u5B9A\u6A94",
    'ptc.pm.your-teams.title': "\u60A8\u7684\u5718\u968A"
};

});


//# sourceMappingURL=zh_TW.50530d6c.js.map
